const groups = [
  [
    ["KATĖ", "🐱"],
    ["ŠUO", "🐶"],
    ["LAPĖ", "🦊"],
  ],
  [
    ["MEŠKA", "🐻"],
    ["LIŪTAS", "🦁"],
    ["PELĖ", "🐭"],
  ],
  [
    ["KARVĖ", "🐮"],
    ["KIAULĖ", "🐷"],
    ["VIŠTA", "🐔"],
  ],
  [
    ["ŽUVIS", "🐟"],
    ["VĖŽLYS", "🐢"],
    ["VARLĖ", "🐸"],
  ],
  [
    ["OBUOLYS", "🍎"],
    ["KRIAUŠĖ", "🍐"],
    ["BANANAS", "🍌"],
  ],
  [
    ["BRAŠKĖ", "🍓"],
    ["VYŠNIA", "🍒"],
    ["ARBŪZAS", "🍉"],
  ],
  [
    ["DUONA", "🍞"],
    ["SŪRIS", "🧀"],
    ["KIAUŠINIS", "🥚"],
  ],
  [
    ["SAULĖ", "☀️"],
    ["MĖNULIS", "🌙"],
    ["ŽVAIGŽDĖ", "⭐"],
  ],
  [
    ["NAMAS", "🏠"],
    ["MAŠINA", "🚗"],
    ["KAMUOLYS", "⚽"],
  ],
  [
    ["LAIMINGAS", "😀"],
    ["LIŪDNAS", "😢"],
    ["PIKTAS", "😠"],
  ],
  [
    ["ARKLYS", "🐴"],
    ["OŽKA", "🐐"],
    ["AVIS", "🐑"],
  ],
  [
    ["VILKAS", "🐺"],
    ["ELNIAS", "🦌"],
    ["KIŠKIS", "🐇"],
  ],
  [
    ["DRAMBLYS", "🐘"],
    ["ŽIRAFA", "🦒"],
    ["BEŽDŽIONĖ", "🐒"],
  ],
  [
    ["BANGINIS", "🐋"],
    ["RYKLYS", "🦈"],
    ["KRABAS", "🦀"],
  ],
  [
    ["ANTIS", "🦆"],
    ["ŽĄSIS", "🪿"],
    ["PELĖDA", "🦉"],
  ],
  [
    ["BITĖ", "🐝"],
    ["SKRUZDĖ", "🐜"],
    ["MUSĖ", "🪰"],
  ],
  [
    ["BORUŽĖ", "🐞"],
    ["DRUGYS", "🦋"],
    ["SRAIGĖ", "🐌"],
  ],
  [
    ["ASILIUKAS", "🫏"],
    ["TRIUŠIS", "🐰"],
    ["KALAKUTAS", "🦃"],
  ],
  [
    ["ANANASAS", "🍍"],
    ["MANGAS", "🥭"],
    ["KOKOSAS", "🥥"],
  ],
  [
    ["VYNUOGĖ", "🍇"],
    ["KIVIS", "🥝"],
    ["PERSIKAS", "🍑"],
  ],
  [
    ["CITRINA", "🍋"],
    ["APELSINAS", "🍊"],
    ["MELIONAS", "🍈"],
  ],
  [
    ["MORKA", "🥕"],
    ["BUROKAS", "🫜"],
    ["SVOGŪNAS", "🧅"],
  ],
  [
    ["BULVĖ", "🥔"],
    ["KOPŪSTAS", "🥬"],
    ["ŽIRNIS", "🫛"],
  ],
  [
    ["PYRAGAS", "🍰"],
    ["RYŽIAI", "🍚"],
    ["MAKARONAI", "🍝"],
  ],
  [
    ["PIENAS", "🥛"],
    ["SVIESTAS", "🧈"],
    ["KOŠĖ", "🥣"],
  ],
  [
    ["SRIUBA", "🍲"],
    ["PICA", "🍕"],
    ["LEDAI", "🍦"],
  ],
  [
    ["SULTYS", "🧃"],
    ["ARBATA", "🍵"],
    ["KAKAVA", "☕"],
  ],
  [
    ["PUODELIS", "☕"],
    ["LĖKŠTĖ", "🍽️"],
    ["ŠAUKŠTAS", "🥄"],
  ],
  [
    ["MEDUS", "🍯"],
    ["RIEŠUTAI", "🥜"],
    ["SALDAINIS", "🍬"],
  ],
  [
    ["KEPURĖ", "🧢"],
    ["ŠALIKAS", "🧣"],
    ["KOJINĖ", "🧦"],
  ],
  [
    ["PALTAS", "🧥"],
    ["MAIKĖ", "👕"],
    ["KELNĖS", "👖"],
  ],
  [
    ["BATAS", "👟"],
    ["PIRŠTINĖ", "🧤"],
    ["AKINIAI", "👓"],
  ],
  [
    ["RANKA", "✋"],
    ["KOJA", "🦶"],
    ["NOSIS", "👃"],
  ],
  [
    ["AKIS", "👁️"],
    ["AUSIS", "👂"],
    ["BURNA", "👄"],
  ],
  [
    ["KIRPIMAS", "💇"],
    ["DANTIS", "🦷"],
    ["LIEŽUVIS", "👅"],
  ],
  [
    ["DURYS", "🚪"],
    ["LANGAS", "🪟"],
    ["SKAMBUTIS", "🔔"],
  ],
  [
    ["KĖDĖ", "🪑"],
    ["LOVA", "🛏️"],
    ["SOFA", "🛋️"],
  ],
  [
    ["MUILAS", "🧼"],
    ["KREMAS", "🧴"],
    ["ŠUKOS", "🪮"],
  ],
  [
    ["LEMPA", "💡"],
    ["VAZA", "🏺"],
    ["LAIKRODIS", "⏰"],
  ],
  [
    ["VIRYKLĖ", "🍳"],
    ["PUODAS", "🍲"],
    ["ČIAUPAS", "🚰"],
  ],
  [
    ["KNYGA", "📖"],
    ["RAŠIKLIS", "🖊️"],
    ["PIEŠTUKAS", "✏️"],
  ],
  [
    ["POPIERIUS", "📄"],
    ["DAŽAI", "🎨"],
    ["ŽIRKLĖS", "✂️"],
  ],
  [
    ["MEŠKIUKAS", "🧸"],
    ["ROBOTAS", "🤖"],
    ["TRAUKINYS", "🚂"],
  ],
  [
    ["AITVARAS", "🪁"],
    ["VILKELIS", "🪀"],
    ["KALADĖ", "🧱"],
  ],
  [
    ["DĖLIONĖ", "🧩"],
    ["KAULIUKAS", "🎲"],
    ["BŪGNAS", "🥁"],
  ],
  [
    ["GITARA", "🎸"],
    ["FLEITA", "🪈"],
    ["PIANINAS", "🎹"],
  ],
  [
    ["PAČIŪŽOS", "⛸️"],
    ["ROGĖS", "🛷"],
    ["SLIDĖS", "🎿"],
  ],
  [
    ["RAKETĖ", "🎾"],
    ["LANKAS", "🏹"],
    ["VARTAI", "🥅"],
  ],
  [
    ["AUTOBUSAS", "🚌"],
    ["TAKSI", "🚕"],
    ["DVIRATIS", "🚲"],
  ],
  [
    ["VALTIS", "🛶"],
    ["LAIVAS", "🚢"],
    ["LĖKTUVAS", "✈️"],
  ],
  [
    ["KELIAS", "🛣️"],
    ["TILTAS", "🌉"],
    ["BĖGIAI", "🛤️"],
  ],
  [
    ["LIETUS", "🌧️"],
    ["SNIEGAS", "❄️"],
    ["VĖJAS", "💨"],
  ],
  [
    ["DEBESIS", "☁️"],
    ["RŪKAS", "🌫️"],
    ["AUDRA", "⛈️"],
  ],
  [
    ["VASARA", "🏖️"],
    ["ŽIEMA", "☃️"],
    ["RUDUO", "🍂"],
  ],
  [
    ["RYTAS", "🌅"],
    ["VAKARAS", "🌇"],
    ["NAKTIS", "🌃"],
  ],
  [
    ["RAMUNĖ", "🌼"],
    ["ROŽĖ", "🌹"],
    ["TULPĖ", "🌷"],
  ],
  [
    ["MEDIS", "🌳"],
    ["EGLĖ", "🌲"],
    ["KRŪMAS", "🌿"],
  ],
  [
    ["KASTUVAS", "🪏"],
    ["VAZONAS", "🪴"],
    ["DAIGAS", "🌱"],
  ],
  [
    ["SMĖLIS", "🏖️"],
    ["AKMUO", "🪨"],
    ["LAPAS", "🍃"],
  ],
  [
    ["UOLA", "🪨"],
    ["KALNAS", "⛰️"],
    ["VULKANAS", "🌋"],
  ],
  [
    ["MIŠKAS", "🌲"],
    ["PIEVA", "🌾"],
    ["SALA", "🏝️"],
  ],
  [
    ["RAUDONA", "🟥"],
    ["MĖLYNA", "🟦"],
    ["ŽALIA", "🟩"],
  ],
  [
    ["GELTONA", "🟨"],
    ["BALTA", "⬜"],
    ["JUODA", "⬛"],
  ],
  [
    ["ORANŽINĖ", "🟧"],
    ["RUDA", "🟫"],
    ["VIOLETINĖ", "🟪"],
  ],
  [
    ["TRAKTORIUS", "🚜"],
    ["RAKETA", "🚀"],
    ["KRANAS", "🏗️"],
  ],
  [
    ["KOALA", "🐨"],
    ["LAMA", "🦙"],
    ["ŪDRA", "🦦"],
  ],
  [
    ["VIKŠRAS", "🐛"],
    ["ŽIOGAS", "🦗"],
    ["SLIEKAS", "🪱"],
  ],
  [
    ["AVOKADAS", "🥑"],
    ["POMIDORAS", "🍅"],
    ["KUKURŪZAS", "🌽"],
  ],
  [
    ["PARKAS", "🏞️"],
    ["SODAS", "🍎"],
    ["KIEMAS", "🏡"],
  ],
  [
    ["MOKYKLA", "🏫"],
    ["LIGONINĖ", "🏥"],
    ["PILIS", "🏰"],
  ],
  [
    ["UOSTAS", "⚓"],
    ["STOTIS", "🚉"],
    ["BOKŠTAS", "🗼"],
  ],
  [
    ["BALIONAS", "🎈"],
    ["ŠIRDIS", "❤️"],
    ["ŽAIBAS", "⚡"],
  ],
  [
    ["TELEFONAS", "📱"],
    ["KOMPASAS", "🧭"],
    ["ŽIBINTAS", "🔦"],
  ],
  [
    ["RADIJAS", "📻"],
    ["KAMERA", "📷"],
    ["ŽAIDIMAS", "🎮"],
  ],
  [
    ["TAŠĖ", "👜"],
    ["PINIGINĖ", "👛"],
    ["RAKTAS", "🔑"],
  ],
  [
    ["ŠLUOTA", "🧹"],
    ["KIBIRAS", "🪣"],
    ["ŠLUOSTĖ", "🧽"],
  ],
  [
    ["DĖŽĖ", "📦"],
    ["LAIŠKAS", "✉️"],
    ["PAŠTAS", "📮"],
  ],
  [
    ["PLAKTUKAS", "🔨"],
    ["VINIS", "📌"],
    ["PJŪKLAS", "🪚"],
  ],
  [
    ["VEIDRODIS", "🪞"],
    ["KEMPINĖ", "🧽"],
    ["DANTUKAS", "🦷"],
  ],
  [
    ["LAGAMINAS", "🧳"],
    ["BILIETAS", "🎫"],
    ["ŽEMĖLAPIS", "🗺️"],
  ],
  [
    ["BANGA", "🌊"],
    ["PLŪDĖ", "🛟"],
    ["SKĖTIS", "☂️"],
  ],
  [
    ["PALAPINĖ", "⛺"],
    ["LAUŽAS", "🔥"],
    ["KUPRINĖ", "🎒"],
  ],
  [
    ["TORTAS", "🎂"],
    ["ŽVAKĖ", "🕯️"],
    ["DOVANA", "🎁"],
  ],
  [
    ["GYVATĖ", "🐍"],
    ["DRIEŽAS", "🦎"],
    ["KROKODILAS", "🐊"],
  ],
  [
    ["EŽYS", "🦔"],
    ["VOVERĖ", "🐿️"],
    ["BEBRAS", "🦫"],
  ],
  [
    ["STIRNA", "🦌"],
    ["ŠERNAS", "🐗"],
    ["BRIEDIS", "🫎"],
  ],
  [
    ["ZEBRAS", "🦓"],
    ["PANDA", "🐼"],
    ["TIGRAS", "🐯"],
  ],
  [
    ["BALANDIS", "🕊️"],
    ["GULBĖ", "🦢"],
    ["ERELIS", "🦅"],
  ],
  [
    ["PAPŪGA", "🦜"],
    ["PINGVINAS", "🐧"],
    ["POVAS", "🦚"],
  ],
  [
    ["RUONIS", "🦭"],
    ["MEDŪZA", "🪼"],
    ["MIDIJA", "🦪"],
  ],
  [
    ["DELFINAS", "🐬"],
    ["KALMARAS", "🦑"],
    ["LAŠIŠA", "🐟"],
  ],
  [
    ["DOBILAS", "☘️"],
    ["KAKTUSAS", "🌵"],
    ["PALMĖ", "🌴"],
  ],
  [
    ["GRYBAS", "🍄"],
    ["KAŠTONAS", "🌰"],
    ["KANKORĖŽIS", "🌲"],
  ],
  [
    ["VĖLIAVA", "🚩"],
    ["VOKAS", "✉️"],
    ["SIUNTINYS", "📦"],
  ],
  [
    ["LEMPUTĖ", "💡"],
    ["BATERIJA", "🔋"],
    ["ŽADINTUVAS", "⏰"],
  ],
  [
    ["KARŪNA", "👑"],
    ["ŽIEDAS", "💍"],
    ["DEIMANTAS", "💎"],
  ],
  [
    ["TAIKINYS", "🎯"],
    ["MEDALIS", "🏅"],
    ["TAURĖ", "🏆"],
  ],
  [
    ["KŪGIS", "🚧"],
    ["ŽENKLAS", "🚸"],
    ["ŠALMAS", "⛑️"],
  ],
  [
    ["KEPTUVĖ", "🍳"],
    ["ORKAITĖ", "♨️"],
    ["VIRDULYS", "🫖"],
  ],
  [
    ["PALETĖ", "🎨"],
    ["KREIDELĖ", "🖍️"],
    ["TEPTUKAS", "🖌️"],
  ],
];

export const WORDS = groups.flatMap((group) =>
  group.map(([word, emoji]) => ({
    word,
    emoji,
    choices: group.map(([, choiceEmoji]) => choiceEmoji),
  }))
);
